<template>
  <v-container fluid class="order-detail d-flex flex-column px-0" v-if="order">
    <CategoryTitle :category="category" />

    <v-row justify="space-between" class="order-detail-wrapper my-3">
      <v-col cols="12" sm="4">
        <CartInfoServiceCard :shippingAddress="order.shippingAddress" />
      </v-col>
      <v-col cols="12" sm="4">
        <CartInfoAddressCard :shippingAddress="order.shippingAddress" />
      </v-col>
      <v-col cols="12" sm="4">
        <CartInfoTimeslotCard
          v-if="order"
          :shippingAddress="order.shippingAddress"
          :timeslot="order.timeslot"
          class="cart-info-timeslot-card"
        />
      </v-col>
    </v-row>
    <OrderDetailInfo class="card my-5" :order="order" :isRider="true" />

    <div class="mb-4">
      <strong class="d-block">{{
        $t("paymentType." + order.paymentTypeId)
      }}</strong>
      <span class="d-block"
        ><strong>{{ $t("rider.orders.orderDetail.doorbellName") }}</strong
        >{{ order.shippingAddress.doorbellName }}</span
      >
      <span class="d-block"
        ><strong>{{ $t("rider.orders.orderDetail.floor") }}</strong>
        {{ order.shippingAddress.floor }}</span
      >
      <span class="d-block"
        ><strong>{{ $t("rider.orders.orderDetail.name") }}</strong>
        {{ order.user.name }}</span
      >
    </div>

    <v-card outlined>
      <CheckoutSummary
        :orderCart="order"
        class="card summary default--text"
        :isOrderDetail="true"
      />
    </v-card>

    <OrderDetailTable
      :suborders="order.suborders"
      :order="order"
      class="mt-4 mt-sm-12"
    />

    <v-row
      no-gutters
      class="backbtn-container mt-5 justify-center justify-sm-start"
    >
      <v-btn color="primary" outlined :to="{ name: 'Rider' }">
        <v-icon class="mr-3">$prev</v-icon>
        <span v-html="$t('orders.button.backToOrders')"></span>
      </v-btn>
    </v-row>
  </v-container>
</template>
<style lang="scss">
.order-detail {
  &-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    @media screen and (min-width: 600px) {
      display: flex;
    }
    .card {
      padding: 10px 20px !important;
      box-sizing: border-box;
      background-color: var(--v-grey-lighten2) !important;
      border: 1px solid var(--v-grey-lighten2) !important;
      border-radius: 8px;
      &:hover {
        background-color: var(--v-primary-lighten2);
      }
      &.cart-info {
        padding: 35px 0 27px 12px !important;
        .text,
        .value {
          line-height: 24px !important;
        }
        @media #{map-get($display-breakpoints, 'sm-only')} {
          padding: 20px !important;
        }
      }
    }
  }
}

@media print {
  .order-detail {
    .cart-info-cards {
      flex-direction: row !important;
      gap: 12px !important;
    }

    .cart-info-cards div:first-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
<script>
// @ is an alias to /src
import OrderDetailTable from "@/components/orders/OrderDetailTable.vue";
import OrderDetailInfo from "@/components/orders/OrderDetailInfo.vue";
import CartInfoAddressCard from "@/components/cart/CartInfoAddressCard.vue";
import CartInfoTimeslotCard from "@/components/cart/CartInfoTimeslotCard.vue";
import CartInfoServiceCard from "@/components/cart/CartInfoServiceCard.vue";
import CheckoutSummary from "@/components/cart/CheckoutSummary.vue";
import CategoryTitle from "@/components/category/CategoryTitle.vue";

import OrderService from "~/service/orderService";
import AnalyticsService from "~/service/analyticsService";

import categoryMixins from "~/mixins/category";
import reload from "~/mixins/reload";

import { mapState, mapActions } from "vuex";
import baskoCustomService from "@/service/baskoCustomService";

export default {
  name: "RiderOrderDetail",
  data() {
    return {
      order: null,
      valid: true
    };
  },
  mixins: [categoryMixins, reload],
  components: {
    OrderDetailInfo,
    OrderDetailTable,
    CartInfoAddressCard,
    CartInfoTimeslotCard,
    CartInfoServiceCard,
    CheckoutSummary,
    CategoryTitle
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    // canIRateOrder() {
    //   return this.order.orderStatusId === 8 || this.order.orderStatusId === 18;
    // },
    enableSave() {
      return !this.valid;
    },
    serviceImg() {
      return this.$t(
        "navbar.service." +
          this.order.shippingAddress.deliveryServiceId +
          ".icon",
        {
          color: "color"
        }
      );
    }
  },
  methods: {
    // getTimeslotTime(time) {
    //   if (time) {
    //     const parseTime = this.am_pm_to_hours(time);
    //     var d = new Date();
    //     var timeMatch = parseTime.match(/(\d+)(?::(\d\d))?\s*(p?)/);
    //     d.setHours(parseInt(timeMatch[1]) + (timeMatch[3] ? 12 : 0));
    //     d.setMinutes(parseInt(timeMatch[2]) || 0);
    //     const timeOnly = this.$dayjs(d).format("HH:mm");
    //     return timeOnly;
    //   } else return "";
    // },
    // am_pm_to_hours(time) {
    //   var hours = Number(time.match(/^(\d+)/)[1]);
    //   var minutes = Number(time.match(/:(\d+)/)[1]);
    //   var AMPM = time.match(/\s(.*)$/)[1];
    //   if (AMPM == "PM" && hours < 12) hours = hours + 12;
    //   if (AMPM == "AM" && hours == 12) hours = hours - 12;
    //   var sHours = hours.toString();
    //   var sMinutes = minutes.toString();
    //   if (hours < 10) sHours = "0" + sHours;
    //   if (minutes < 10) sMinutes = "0" + sMinutes;
    //   return sHours + ":" + sMinutes;
    // },
    ...mapActions({
      addProductsFromOrder: "cart/addProductsFromOrder",
      loadCart: "cart/loadCart"
    }),
    async addAllToCart({ orderId }) {
      let res = await global.vm.$dialog.confirm({
        text: global.vm.$t("message.addAllFromOrder")
      });
      if (res) {
        await this.addProductsFromOrder(orderId);
      }
    },
    async deleteOrder({ orderId }) {
      let res = await this.$dialog.confirm({
        text: global.vm.$t("message.removeOrder", {
          orderId: orderId
        })
      });

      if (res) {
        await OrderService.deleteOrder(orderId);
        AnalyticsService.refund(this.order);
        await this.reload(orderId);
      }
    },
    async editOrder({ orderId }) {
      try {
        let res = await global.vm.$dialog.confirm({
          text: global.vm.$t("message.confirmOrderEdit")
        });
        if (res) {
          await OrderService.editOrder(orderId);
          this.loadCart();
          this.$router.push({
            name: "Cart"
          });
        }
      } catch (err) {
        global.EventBus.$emit("error", {
          error: err,
          message: global.EventBus.$t("errors.errorOnOrderEditConfirm")
        });
        return null;
      }
    },
    async fetchOrder(orderId) {
      this.order = await baskoCustomService.getOrder(orderId);
    }
  },
  created() {
    this.fetchOrder(this.$route.params.orderId);
  }
};
</script>
